/** @jsx jsx */
import { jsx } from 'theme-ui';
export var CustomCheckboxField = function (_a) {
    var children = _a.children, value = _a.value, onChange = _a.onChange, disabled = _a.disabled, className = _a.className;
    return (jsx("div", { className: className },
        jsx("label", { sx: {
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'center',
                cursor: disabled ? 'default' : 'pointer',
            }, onClick: function (e) { return e.stopPropagation(); } },
            jsx("input", { type: "checkbox", sx: { mr: 2, cursor: 'pointer' }, checked: value, disabled: disabled, onChange: function (e) {
                    onChange(e.target.checked);
                } }),
            jsx("div", { sx: { color: disabled ? 'muted' : undefined } }, children))));
};
//# sourceMappingURL=CustomCheckboxField.js.map